import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10d9ccdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-header--title" }
const _hoisted_5 = {
  key: 0,
  class: "card-header--tooltip"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-question-circle" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "error-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "error-container--error-message" }, " Whoops, there’s an error... 😅 ", -1))
const _hoisted_10 = {
  key: 1,
  class: "footer"
}
const _hoisted_11 = { class: "response-count" }

import { computed } from 'vue'
import { IconDefinition } from 'fontawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import Button from 'primevue/button'

interface Props {
    icon: IconDefinition
    title: string
    showFooter?: boolean
    responseCount?: number | undefined
    actionLabel?: string
    onActionClick?: Function
    showError?: boolean
    onReloadClick?: Function
    tooltip?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardCard',
  props: {
    icon: {},
    title: {},
    showFooter: { type: Boolean, default: true },
    responseCount: { default: undefined },
    actionLabel: { default: '' },
    onActionClick: { type: Function, default: () => ({}) },
    showError: { type: Boolean, default: false },
    onReloadClick: { type: Function, default: () => ({}) },
    tooltip: { default: '' }
  },
  setup(__props: any) {

const props = __props

const responseCountLabel = computed(() => {
    if (props.responseCount === undefined) {
        return ''
    }
    const formattedCount = props.responseCount.toLocaleString()
    return `${formattedCount} ${props.responseCount === 1 ? 'response' : 'responses'}`
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", {
    class: "frontline-manager-dashboard-card",
    "aria-label": _ctx.title
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: _ctx.icon,
          class: "card-header--icon"
        }, null, 8, ["icon"]),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _renderSlot(_ctx.$slots, "title-suffix"),
        _renderSlot(_ctx.$slots, "header"),
        (_ctx.tooltip)
          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7)), [
              [_directive_tooltip, {
                        value: _ctx.tooltip,
                        pt: {
                            root: {
                                style: {
                                    'max-width': '300px',
                                },
                            },
                            text: {
                                style: {
                                    background: 'white',
                                    color: '#334054',
                                    boxShadow:
                                        '0px 0px 10px 3px rgba(0, 0, 0, 0.2)',
                                    'text-align': 'center',
                                },
                            },
                            arrow: {
                                style: {
                                    'border-top-color': 'white',
                                    'border-left-color': 'white',
                                    'border-right-color': 'white',
                                },
                            },
                        },
                    }]
            ])
          : _createCommentVNode("", true)
      ]),
      (!_ctx.showError)
        ? _renderSlot(_ctx.$slots, "content", { key: 0 })
        : (_ctx.$slots.errorContent)
          ? _renderSlot(_ctx.$slots, "errorContent", { key: 1 })
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_unref(Button), {
                label: "Reload",
                class: "error-container--reload-button",
                outlined: "",
                severity: "secondary",
                onClick: _ctx.onReloadClick
              }, null, 8, ["onClick"])
            ]))
    ]),
    (!_ctx.showError)
      ? _renderSlot(_ctx.$slots, "contentNoPadding", { key: 0 })
      : _createCommentVNode("", true),
    (_ctx.showFooter)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(responseCountLabel.value), 1),
          (_ctx.actionLabel)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                link: "",
                class: "card-action-button",
                "data-testid": "fm-dash-card-action-button",
                label: _ctx.actionLabel,
                onClick: _ctx.onActionClick
              }, null, 8, ["label", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})